var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteXIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 6 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Molecules",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons/standard-revoke/normal",
    transform: "translate(-68.000000, -13.000000)",
    stroke: "currentColor",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4,6.6 L54.6,11.4 M54.6,6.6 L59.4,11.4",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteXIcon);
export default __webpack_public_path__ + "static/media/delete-x-icon.a0c9f6ee929d4fed8e9101f963690a88.svg";
export { ForwardRef as ReactComponent };